export const DELETE_BASES = "DELETE_BASES";
export const deleteBasesAction = (bases) => {
  return {
    type: "DELETE_BASES",
    payload: bases,
  };
};

export const FETCH_BASES = "FETCH_BASES";
export const fetchBasesAction = (bases) => {
  return {
    type: "FETCH_BASES",
    payload: bases,
  };
};

export const INIT_BASES = "INIT_BASES";
export const initBasesAction = () => {
  return {
    type: "INIT_BASES",
    payload: null,
  };
};
